<div class="px-6 pt-6">
  <h1 class="headline-small text-primary text-center m-0">{{ title }}</h1>
  <p class="body-medium text-on-surface-variant text-left mt-3 mb-0 mx-auto max-w-prose" data-testid="recipient-manual-note">
    <span class="font-bold">{{ 'Please note:' | translate }}</span>
    {{ 'Text entered here will appear on the task and may contain an address. Ensure it complies with legal and policy requirements.' | translate }}
  </p>
</div>

<app-dialog-content>
  <div class="flex flex-col gap-6">
    <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
      <textarea
        matInput
        id="recipient-manual-address"
        rows="3"
        class="min-h-[58px]"
        [(ngModel)]="content"
        [placeholder]="'Enter recipient details here' | translate"
        data-testid="recipient-manual-input"></textarea>
    </mat-form-field>
  </div>
</app-dialog-content>

<app-dialog-footer>
  <div class="flex justify-end w-full gap-3">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="close()"
      class="!px-6 [--mdc-outlined-button-container-height:48px]"
      data-testid="recipient-manual-cancel">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="!canSave"
      (click)="save()"
      class="!px-6 [--mdc-filled-button-container-height:48px]"
      data-testid="recipient-manual-save">
      {{ 'Save' | translate }}
    </button>
  </div>
</app-dialog-footer>
